import { View } from "@src/components";
import { memo } from "react";
import { SelectableUserListItem } from "./SelectableUserListItem";
import type { UserWithSites } from "@src/features/settings/data/mock-all-users";
import { StyleSheet } from "react-native-unistyles";
import { Text } from "@src/components";

type SelectableUserListProps = {
  users: UserWithSites[];
  selectedUserIds: Set<string>;
  onToggleUser: (userId: string) => void;
};

export const SelectableUserList = memo(({ users, selectedUserIds, onToggleUser }: SelectableUserListProps) => {
  if (users.length === 0) {
    return (
      <View style={styles.emptyStateContainer}>
        <Text textStyle="sm/regular" color="textMuted" textAlign="center">
          No users found
        </Text>
      </View>
    );
  }
  return (
    <View bg="surfaceCard" style={styles.container}>
      {users.map((user, index) => (
        <SelectableUserListItem
          key={user.id}
          user={user}
          index={index}
          usersLength={users.length}
          selected={selectedUserIds.has(user.id)}
          onToggle={onToggleUser}
        />
      ))}
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    borderRadius: theme.spacing.md,
    borderWidth: 1,
    borderColor: theme.colors.borderCard,
    overflow: "hidden",
  },
  emptyStateContainer: {
    paddingVertical: theme.spacing["5xl"],
  },
}));
